import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import { GButton, GInput } from 'tennders-common/form/components'
import useMailTemplate from 'tennders-transactions/hooks/useMailTemplate'
import { apiPost } from 'tennders-stracture/libs/api'
// eslint-disable-next-line no-use-before-define
import { useToast } from 'tennders-common/hooks/useToast'
import GModal from 'tennders-market/common/components/element/GModal'
import { ModalProps } from 'tennders-common/types/ModalProps'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'

type EditorProps = {
  style ?: React.CSSProperties,
  className ?: string,
  text ?: string,
  id ?: string,
  options ?: Record<string, any>
}
const Editor = dynamic<EditorProps>(() => import('react-medium-editor'))
// ES module
// load theme styles with webpack
// eslint-disable-next-line import/no-extraneous-dependencies
require('medium-editor/dist/css/medium-editor.css')
// eslint-disable-next-line import/no-extraneous-dependencies
require('medium-editor/dist/css/themes/default.css')

interface StatusUpdateForm {
  message ?: string,
  subject ?: string,
  transaction ?: number,
  action ?: string,
  email ?: string
}
const MStatusUpdateEmail = (props : ModalProps) => {
  const { mailtemplate, mailtransaction, setmailtemplate } = useMailTemplate()
  const box_name = process.env.NEXT_PUBLIC_BOX_NAME
  const { toastSuccess } = useToast()
  const [form, setform] = useState<StatusUpdateForm>({})
  const { t } = useTranslation()
  const [submitting, setsubmitting] = useState(false)
  const onChange = (k, v) => setform({ ...form, [k]: v })

  useEffect(() => {
    setform({
      ...form,
      message: mailtemplate?.content || '',
      subject: mailtemplate?.title || '',
      transaction: mailtransaction?.id,
      action: mailtemplate?.action,
      email: ''
    })
  }, [mailtransaction, mailtemplate])

  const send = async () => {
    setsubmitting(true)
    await apiPost('transactions/send-status-update',
      { ...form, message: document.getElementById('cucueditor').innerHTML })
    setsubmitting(false)
    toastSuccess(t('modal:emailSent'))
    setmailtemplate(false)
  }

  return (
    <GModal
      isOpen={!!mailtemplate}
      size={800}
      close={() => setmailtemplate(false)}
      {...props}
    >

      <div className="tennders-modal-body w-100">

        <div className="d-flex">

          <div className="col-2">
            <div className="p-20">
              <h3 className="bold">{t('modal:sendEmailToCustomer')}</h3>

              <GInput
                type="email"
                placeholder={t('modal:receipentMail')}
                name="email"
                maxLength={INPUT_CHARACTER_LIMITS.EMAIL}
                form={form}
                onChange={onChange}
              />
              <GInput
                name="subject"
                form={form}
                onChange={onChange}
                placeholder={t('modal:newMessageFromTennders', { box_name })}
              />

            </div>
          </div>
          <div className="col-2  bg-color-light-gray">
            <div className="p-20">
              <div className="text-12">{t('modal:youreUsingThisTemplate')}</div>
              <h3 className="bold">{mailtemplate && mailtemplate.title}</h3>

              {mailtemplate && (
                <Editor
                  style={{ height: 300, overflow: 'overlay' }}
                  className="form-textarea"
                  text={mailtemplate?.content}
                  id="cucueditor"
                  options={{ toolbar: { buttons: ['bold', 'italic', 'underline'] } }}
                />
              ) }

              <GButton
                disabled={!form.message || form.message.length === 0
                   || !form.subject || form.subject.length === 0 || !form.email || form.email.length === 0}
                onClick={send}
                submitting={submitting}
                className="mt-10 btn standard-btn cursor-pointer"
              >
                {t('modal:sendEmail')}
              </GButton>
            </div>
          </div>
        </div>
      </div>

    </GModal>
  )
}

export default MStatusUpdateEmail
